import { useState, FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './../../reducer';
import { LinearProgress, Tabs } from '../../tailwindcomponents';
import VacationCalendar from './VacationCalendar';
import MyVacationRequests from './MyVacationRequests';
import TimeControlVacationRequests from './TimeControlVacationRequests';
import SlotsAndPeriods from './SlotsAndPeriods';
import { useQueryTab } from '../../utils/usePersistedTab';

const Vacations: FunctionComponent = () => {
  const store = useSelector((state: RootState) => state);
  const { tabValue, setTabValue } = useQueryTab("tab", 0);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [selectedLocation, setSelectedLocation] = useState<string>("");

  const isTimeControlAdmin = store.user.me.user_clearence_groups.includes("Vacation Admin");
  const tabs = isTimeControlAdmin ? ["Leave Calendar", "Time Control", "Slots & Periods"] : ["Vacation Calendar", "My Requests"];
  
  
  const handleCategoryChange = (e: string) => {
    setSelectedCategory(e);
    if(e !== selectedCategory) {
      setSelectedLocation("");
    }
  };

  const handleLocationChange = (location: string) => {
    setSelectedLocation(location);
  };

  useEffect(() => {
    setSelectedCategory("");
    setSelectedLocation("");
  }, [tabValue]);
  
  return (
    <div>
      {loading && <LinearProgress />}
      <Tabs
        tabNames={tabs}
        tabValue={tabValue}
        onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
      />
      {
        isTimeControlAdmin ?
          <div>
            {tabValue === 0 && <VacationCalendar setLoading={setLoading} handleCategoryChange={(e: string) => handleCategoryChange(e)} handleLocationChange={(e: string) => handleLocationChange(e)}  selectedLocation={selectedLocation} selectedCategory={selectedCategory} />}
            {tabValue === 1 && <TimeControlVacationRequests setLoading={setLoading} handleCategoryChange={(e: string) => handleCategoryChange(e)} handleLocationChange={(e: string) => handleLocationChange(e)} setSelectedCategory={setSelectedCategory} setSelectedLocation={setSelectedLocation} selectedLocation={selectedLocation} selectedCategory={selectedCategory} />}
            {tabValue === 2 && <SlotsAndPeriods setLoading={setLoading} handleCategoryChange={(e: string) => handleCategoryChange(e)} handleLocationChange={(e: string) => handleLocationChange(e)} selectedLocation={selectedLocation} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} setSelectedLocation={setSelectedLocation}/>}
          </div>
          :
          <div>
            {tabValue === 0 && <VacationCalendar setLoading={setLoading} handleCategoryChange={(e: string) => handleCategoryChange(e)} handleLocationChange={(e: string) => handleLocationChange(e)}  selectedLocation={selectedLocation} selectedCategory={selectedCategory}/>}
            {tabValue === 1 && <MyVacationRequests />}
          </div>
      }
    </div>
  );
}
export default Vacations;